// frontend/src/services/milhasService.js
import apiService from './apiService';

// --- Portadores de Milhas ---
export const getPortadores = () => {
    return apiService.get('/milhas/portadores/');
};
export const getPortadorDetail = (id) => {
    return apiService.get(`/milhas/portadores/${id}/`);
};
export const createPortador = (portadorData) => {
    return apiService.post('/milhas/portadores/', portadorData);
};
export const updatePortador = (id, portadorData) => {
    return apiService.put(`/milhas/portadores/${id}/`, portadorData);
};
export const deletePortador = (id) => {
    return apiService.delete(`/milhas/portadores/${id}/`);
};

// --- Programas de Fidelidade (Catálogo) ---
export const getProgramasFidelidade = () => {
    return apiService.get('/milhas/programas-fidelidade/');
};

export const createProgramaFidelidade = (data) => {
    return apiService.post('/milhas/programas-fidelidade/', data);
};

export const updateProgramaFidelidade = (id, data) => {
    return apiService.patch(`/milhas/programas-fidelidade/${id}/`, data);
};

export const deleteProgramaFidelidade = (id) => {
    return apiService.delete(`/milhas/programas-fidelidade/${id}/`);
};

// Pedido de programa que ainda não está no catálogo (a equipe cadastra e avisa por e-mail)
export const solicitarProgramaFidelidade = (data) => {
    return apiService.post('/milhas/solicitacoes-programa/', data);
};


// --- Programas do Portador ---
export const getProgramasDoPortador = (portadorId) => {
    let url = '/milhas/programas-portador/';
    if (portadorId) {
        url += `?portador=${portadorId}`;
    }
    return apiService.get(url);
};
export const getProgramaPortadorDetail = (id) => {
    return apiService.get(`/milhas/programas-portador/${id}/`);
};
export const ativarProgramaParaPortador = (data) => {
    return apiService.post('/milhas/programas-portador/', data);
};
export const desativarProgramaPortador = (programaPortadorId) => {
    return apiService.post(`/milhas/programas-portador/${programaPortadorId}/desativar/`);
};

// --- Clubes de Assinatura ---
// CORREÇÃO: Endpoint ajustado para 'clubes' conforme urls.py
export const getClubesDoPrograma = (programaPortadorId) => {
    return apiService.get(`/milhas/clubes/?programa_portador=${programaPortadorId}`);
};
// CORREÇÃO: Endpoint ajustado para 'clubes' conforme urls.py
export const getClubesAssinatura = () => {
    return apiService.get('/milhas/clubes/'); 
};

export const getClubes = (programaPortadorId = null) => {
     const url = programaPortadorId ? `/milhas/clubes/?programa_portador=${programaPortadorId}` : '/milhas/clubes/';
     return apiService.get(url);
};

export const createClubeAssinatura = (clubeData) => {
    return apiService.post('/milhas/clubes/', clubeData);
};
export const updateClubeAssinatura = (id, clubeData) => {
    return apiService.put(`/milhas/clubes/${id}/`, clubeData);
};
export const cancelarClubeAssinatura = (id) => {
    return apiService.post(`/milhas/clubes/${id}/cancelar/`);
};
export const reativarClubeAssinatura = (id) => {
    return apiService.post(`/milhas/clubes/${id}/reativar/`);
};
export const deleteClubeAssinatura = (id) => {
    return apiService.delete(`/milhas/clubes/${id}/`);
};
export const confirmarBonusClube = (projecao) => {
    const payload = {
        id_clube: projecao.id_clube,
        data_projetada: projecao.data_projetada,
    };
    return apiService.post('/milhas/clubes/confirmar-bonus/', payload);
};

// --- Passageiros ---
export const getPassageiros = () => {
    return apiService.get('/milhas/passageiros/');
};

export const createPassageiro = (passageiroData) => {
    return apiService.post('/milhas/passageiros/', passageiroData);
};

export const updatePassageiro = (id, data) => {
    return apiService.patch(`/milhas/passageiros/${id}/`, data);
};

export const deletePassageiro = (id) => {
    return apiService.delete(`/milhas/passageiros/${id}/`);
};

// --- Controle de CPFs ---
export const getControleCpfs = () => {
    return apiService.get('/milhas/controle-cpfs/');
};

// --- Usos de CPF Informados (emissões anteriores ao uso do sistema) ---
export const getUsosCpfInformados = (programaPortadorId = null) => {
    const url = programaPortadorId
        ? `/milhas/usos-cpf-informados/?programa_portador=${programaPortadorId}`
        : '/milhas/usos-cpf-informados/';
    return apiService.get(url);
};

export const createUsoCpfInformado = (data) => {
    return apiService.post('/milhas/usos-cpf-informados/', data);
};

export const updateUsoCpfInformado = (id, data) => {
    return apiService.patch(`/milhas/usos-cpf-informados/${id}/`, data);
};

export const deleteUsoCpfInformado = (id) => {
    return apiService.delete(`/milhas/usos-cpf-informados/${id}/`);
};

// --- Emissões de Passagem ---
export const getEmissoes = () => {
    return apiService.get('/milhas/emissoes/');
};

export const cancelarEmissao = (id) => {
    return apiService.post(`/milhas/emissoes/${id}/cancelar/`);
};


// --- Transações de Milhas ---
export const getTransacoesMilhas = async (params = {}) => {
    const response = await apiService.get('/milhas/transacoes/', { params });
    const data = response?.data ?? response;
    return Array.isArray(data) ? data : [];
};

export const getTransacoesDoPrograma = (programaPortadorId) => {
    return apiService.get(`/milhas/transacoes/?programa_portador=${programaPortadorId}`);
};

export const getTransacoesDoPortador = (portadorId) => {
    return apiService.get(`/milhas/transacoes/?portador_id=${portadorId}`);
};

export const createCompraBonificada = async (data) => {
    try {
        const response = await apiService.post('/milhas/transacoes/compra-bonificada/', data);
        return response.data;
    } catch (error) {
        console.error('Erro ao criar compra bonificada:', error.response?.data);
        throw error;
    }
};
 
export const confirmarTransacaoMilhas = async (id, dataEfetiva) => {
    try {
        const response = await apiService.post(
            `/milhas/transacoes/${id}/confirmar/`,
            dataEfetiva ? { data_efetiva: dataEfetiva } : {},
        );
        return response.data;
    } catch (error) {
        console.error('Erro ao confirmar transação de milhas:', error.response?.data);
        throw error;
    }
};

export const reverterTransacaoMilhasParaPendente = async (id) => {
    try {
        const response = await apiService.post(`/milhas/transacoes/${id}/reverter_para_pendente/`);
        return response.data;
    } catch (error) {
        console.error('Erro ao reverter transação de milhas:', error.response?.data);
        throw error;
    }
};

export const createCompraPontos = async (data) => {
    try {
        const response = await apiService.post('/milhas/transacoes/compra-pontos/', data);
        return response.data;
    } catch (error) {
        console.error('Erro ao criar compra de pontos:', error.response?.data);
        throw error;
    }
};

export const createEntradaAvulsa = async (data) => {
    try {
        const response = await apiService.post('/milhas/transacoes/entrada-avulsa/', data);
        return response.data;
    } catch (error) {
        console.error('Erro ao criar entrada avulsa:', error.response?.data);
        throw error;
    }
};

export const createPontosCartao = async (data) => {
    try {
        const response = await apiService.post('/milhas/transacoes/pontos-cartao/', data);
        return response.data;
    } catch (error) {
        console.error('Erro ao criar pontos de cartão:', error.response?.data);
        throw error;
    }
};

export const createBonusRecebidos = async (data) => {
    try {
        const response = await apiService.post('/milhas/transacoes/bonus-recebidos/', data);
        return response.data;
    } catch (error) {
        console.error('Erro ao criar bônus recebidos:', error.response?.data);
        throw error;
    }
};

// --- Lista de Beneficiários (Azul) ---
export const getBeneficiariosLista = (programaPortadorId) => {
    const url = programaPortadorId
        ? `/milhas/beneficiarios-lista/?programa_portador=${programaPortadorId}`
        : '/milhas/beneficiarios-lista/';
    return apiService.get(url);
};
export const addBeneficiarioLista = (data) => {
    return apiService.post('/milhas/beneficiarios-lista/', data);
};
export const removerBeneficiarioLista = (id) => {
    return apiService.post(`/milhas/beneficiarios-lista/${id}/remover/`);
};

// --- NOVOS SERVIÇOS DE SAÍDA ---
export const registrarSaidaAvulsa = async (data) => {
    try {
        const response = await apiService.post('/milhas/transacoes/registrar-saida-avulsa/', data);
        return response.data;
    } catch (error) {
        console.error('Erro ao criar transação de saída avulsa:', error.response?.data);
        throw error;
    }
};

export const registrarVenda = async (data) => {
    try {
        const response = await apiService.post('/milhas/transacoes/registrar-venda/', data);
        return response.data;
    } catch (error) {
        console.error('Erro ao criar operação de venda:', error.response?.data);
        throw error;
    }
};

export const getOperacaoVenda = async (id) => {
    const response = await apiService.get(`/milhas/operacoes-venda/${id}/`);
    return response.data;
};

export const updateOperacaoVenda = async (id, data) => {
    try {
        const response = await apiService.patch(`/milhas/operacoes-venda/${id}/`, data);
        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar operação de venda:', error.response?.data);
        throw error;
    }
};

export const deleteTransacaoMilhas = async (id) => {
    try {
        const response = await apiService.delete(`/milhas/transacoes/${id}/`);
        return response.status === 204;
    } catch (error) {
        console.error('Erro ao excluir transação:', error.response?.data);
        throw error;
    }
};

export const updateTransacaoMilhas = async (id, data) => {
    try {
        const response = await apiService.patch(`/milhas/transacoes/${id}/`, data);
        return response.data;
    } catch (error) {
        console.error('Erro ao editar transação:', error.response?.data);
        throw error;
    }
};


// --- Transferências de Milhas ---
export const createTransferenciaMilhas = (transferenciaData) => {
    return apiService.post('/milhas/transferencias/', transferenciaData);
};
export const createTransferenciaTerceiros = (data) => {
    return apiService.post('/milhas/transferencias-terceiros/', data);
};
export const getTransferenciasUnificadas = () => {
    return apiService.get('/milhas/transferencias-unificadas/');
};
export const deleteTransferenciaMilhas = (id) => {
    return apiService.delete(`/milhas/transferencias/${id}/`);
};
export const deleteTransferenciaTerceiros = (id) => {
    return apiService.delete(`/milhas/transferencias-terceiros/${id}/`);
};
// NOVAS FUNÇÕES DE CONFIRMAÇÃO
export const confirmarTransferenciaMilhas = (id) => {
    return apiService.post(`/milhas/transferencias/${id}/confirmar/`);
};
export const confirmarTransferenciaTerceiros = (id) => {
    return apiService.post(`/milhas/transferencias-terceiros/${id}/confirmar/`);
};

// --- Dashboard de Desempenho ---
export const getDesempenhoMilhas = (portadorId) => {
    let url = '/milhas/desempenho-geral/';
    if (portadorId) {
        url += `?portador_id=${portadorId}`;
    }
    return apiService.get(url);
};

// --- NOVA FUNÇÃO: Radar de Recebíveis ---
export const getMilhasRecebiveis = (portadorId) => {
    const params = portadorId ? { portador_id: portadorId } : {};
    return apiService.get('/milhas/recebiveis-resumo/', { params });
};